























































import Api from "@/api/Api";
import Vue from "vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
export default Vue.extend({
  methods: {
    async doLogin() {
      this.loginError = false;
      await this.login({
        email: this.email,
        password: this.password
      });
      if (this.isGranted(["ROLE_ADMINISTRATOR"])) {
        this.$router.push({ name: "AdministratorIndex" });
      } else if (this.isGranted(["ROLE_ADVERTISER"])) {
        this.$router.push({ name: "AdvertiserIndex" });
      } else {
        this.loginError = true;
      }
    },
    ...mapActions(["login"]),
    ...mapMutations(["updateDocument"])
  },
  data() {
    return {
      email: "",
      password: "",
      loginError: false
    };
  },
  async beforeRouteEnter(to, from, next) {
    await Api.singleton().jwtToken.tryLoadJwtToken();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    next((vm: any) => {
      if (vm.isGranted(["ROLE_ADVERTISER"])) {
        next({ name: "AdvertiserIndex" });
        return;
      }
      if (vm.isGranted(["ROLE_ADMINISTRATOR"])) {
        next({ name: "AdministratorIndex" });
        return;
      }
      vm.$store.dispatch("updateHeaderProcess", undefined);
      next();
    });
  },
  computed: {
    ...mapGetters(["isGranted"])
  }
});
